import { DemandStatus } from '../../Enums/demand-status.enum';

export class GroupDemand {
  id?: string;
  reference?: string;
  status?: DemandStatus;
  status_id?: number;
  created_at?: string;

  constructor(data?: Partial<GroupDemand>) {
    Object.assign(this, data);
  }
}
